import request from '@/api/request.js';

// 广电合同模板表列表
export const getContractTemplateListPage = (data) => {
    return request({
        url: '/order/adm/contractTemplate/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 添加
export const addContractTemplate = (data) => {
    return request({
        url: '/order/adm/contractTemplate/addTemplate',
        method: 'post',
        type: 'json',
        data,
    })
}

// 编辑
export const updateContractTemplate = (data) => {
    return request({
        url: '/order/adm/contractTemplate/updateTemplate',
        method: 'post',
        type: 'json',
        data,
    })
}

// 删除
export const delContractTemplate = (data) => {
    return request({
        url: '/order/adm/contractTemplate/deleteTemplate',
        method: 'post',
        type: 'json',
        data,
    })
}